import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  TextField,
  Select,
  Input,
  MenuItem,
  ListItemText,
  InputLabel,
} from '@material-ui/core';
import { GET_CATEGORIES_BY_SITE } from 'queries/category';
import { useQuery } from '@apollo/client';
import {
  normalizeCategoriesDataFromQuery,
  showCategoryNameWithDepth,
} from 'utils/categories';
import { Toast } from '../Toast';
import useStyles from './styles';
import Loading from '../Loading';

// eslint-disable-next-line camelcase
export default function FormCategory({
  mutationAddCategory,
  siteDomain,
  setSiteDomain,
}) {
  const [saveButtonStatus, setSaveButtonStatus] = useState('');
  const [title, setTitle] = useState();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openLoadingSave, setOpenLoadingSave] = useState(false);
  const [openLoadingCategories, setOpenLoadingCategories] = useState(false);
  const [categoriesFromApi, setCategoriesFromApi] = useState([]);

  const classes = useStyles();

  const queryCategories = useQuery(GET_CATEGORIES_BY_SITE, {
    variables: { siteDomain, reload: false },
    fetchPolicy: 'network-only',
  });

  const handleSelectChange = (event, setSelectedCategory) => {
    if (event.target.value) {
      setSelectedCategory(event.target.value);
    }
  };

  const renderCategoryNameInSelectLabel = (selectedValue) => {
    if (categoriesFromApi.length > 0) {
      return (
        categoriesFromApi.find(
          (categoryFrommApi) => categoryFrommApi.idFromWp === selectedValue,
        ).name || ''
      );
    }

    return selectedValue;
  };

  const handleChange = (event) => {
    setTitle(event.target.value);
  };

  const saveContent = () => {
    setSaveButtonStatus('disabled');
    setOpenLoadingSave(true);
    const values = selectedCategory
      ? { siteDomain, name: title, parent: selectedCategory }
      : { siteDomain, name: title };

    mutationAddCategory({
      variables: values,
    }).then(
      () => {
        Toast('Action executed with success!');
        setSiteDomain(siteDomain);
        setOpenLoadingSave(false);
      },
      (error) => {
        setSaveButtonStatus('');
        Toast(`Action executed with error! Error message: ${error}`, 'error');
        setOpenLoadingSave(false);
      },
    );
  };

  useEffect(() => {
    if (siteDomain) {
      setOpenLoadingCategories(true);

      queryCategories.refetch().then(
        (result) => {
          const {
            data: { contentCategoriesBySite },
          } = result;
          if (contentCategoriesBySite && contentCategoriesBySite.length > 0) {
            const normalizedContentCategoriesBySite = normalizeCategoriesDataFromQuery(
              contentCategoriesBySite,
            );

            setCategoriesFromApi(normalizedContentCategoriesBySite);
          } else {
            setCategoriesFromApi([]);
          }
          setOpenLoadingCategories(false);
        },
        () => {
          // error
          setOpenLoadingCategories(false);
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteDomain]);

  return (
    <form id="myForm">
      <Loading openLoading={openLoadingCategories || openLoadingSave} />
      <Grid container spacing={1}>
        <Grid item xs={10}>
          <TextField
            id="title"
            label="title"
            color="primary"
            onChange={handleChange}
            value={title}
            fullWidth
            multiline={false}
            InputLabelProps={{ shrink: true }}
            placeholder=""
          />
        </Grid>
        <Grid item className={classes.actionButtons} xs={2}>
          <Button
            onClick={() => saveContent()}
            fullWidth
            variant="contained"
            color="primary"
            disabled={saveButtonStatus}
          >
            Save
          </Button>
        </Grid>
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>Parent</InputLabel>
          <Select
            fullWidth
            labelId="category"
            id="category"
            value={selectedCategory}
            onChange={(ev) => handleSelectChange(ev, setSelectedCategory)}
            input={<Input />}
            disabled={!siteDomain}
            renderValue={(selected) => {
              return renderCategoryNameInSelectLabel(selected);
            }}
            MenuProps={classes.MenuProps}
          >
            {categoriesFromApi.map((category) => (
              <MenuItem key={category.idFromWp} value={category.idFromWp}>
                <ListItemText primary={showCategoryNameWithDepth(category)} />
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    </form>
  );
}
